import { DialogContent, DialogContentProps, styled } from '@mui/material';
import { ReactElement } from 'react';

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(5, 11),
    textAlign: 'center',
}));

export const PoolModalContent = (props: DialogContentProps): ReactElement => (
    <StyledDialogContent dividers={true} {...props} />
);
